import { useTranslation } from "react-i18next";
import "../../../i18n";
import SectionLabel from "../components/SectionLabel";
import BrowserFrame from "../components/BrowserFrame";

const BULLET_KEYS = ["b1", "b2", "b3", "b4", "b5"];

const OPTIONS = [
  { letter: "A", text: "25" },
  { letter: "B", text: "24", selected: true },
  { letter: "C", text: "36" },
  { letter: "D", text: "30" },
];

function OnlineTestsSection() {
  const { t } = useTranslation("marketing");

  return (
    <section className="ul-section" style={{ background: "#FFF7ED" }} id="online-tests">
      <div className="ul-feature-split">
        <div className="ul-feature-content">
          <SectionLabel>{t("onlineTests.label")}</SectionLabel>
          <h2 className="ul-section-title">
            {t("onlineTests.titleLine1")}<br />{t("onlineTests.titleLine2")}
          </h2>
          <p className="ul-section-sub">
            {t("onlineTests.sub")}
          </p>
          <ul className="ul-feature-points">
            {BULLET_KEYS.map((b) => (
              <li key={b}>
                <span className="ul-check-icon" aria-hidden="true">✓</span>
                {t(`onlineTests.bullets.${b}`)}
              </li>
            ))}
          </ul>
        </div>

        <div className="ul-feature-visual">
          <div className="ul-card-shell">
            <BrowserFrame domain="app.markszen.com" path="/take/jee-mock-may">
              <div className="ul-card-body">
                <div className="ul-ot-header">
                  <div className="ul-ot-header-left">
                    <div className="ul-ot-section-label">{t("onlineTests.mock.section")}</div>
                    <div className="ul-ot-q-count">{t("onlineTests.mock.qCount")}</div>
                  </div>
                  <div className="ul-ot-header-right">
                    <div className="ul-ot-timer-label">{t("onlineTests.mock.timeLeft")}</div>
                    <div className="ul-ot-timer">23:14</div>
                  </div>
                </div>

                <div className="ul-ot-question">
                  <strong className="ul-ot-q-num">{t("onlineTests.mock.qNum")}</strong>
                  {t("onlineTests.mock.question")}
                </div>

                <div className="ul-ot-options">
                  {OPTIONS.map((opt) => (
                    <div
                      key={opt.letter}
                      className={`ul-ot-option${opt.selected ? " selected" : ""}`}
                    >
                      <span className="ul-ot-option-letter">{opt.letter}</span>
                      <span className="ul-ot-option-text">{opt.text}</span>
                      {opt.selected && (
                        <span className="ul-ot-option-check" aria-hidden="true">✓</span>
                      )}
                    </div>
                  ))}
                </div>

                <div className="ul-ot-status-row">
                  <span className="ul-ot-chip ul-ot-chip-green">
                    {t("onlineTests.mock.chipTabSwitch")}
                  </span>
                  <span className="ul-ot-chip ul-ot-chip-green">
                    {t("onlineTests.mock.chipAutoSubmit")}
                  </span>
                  <span className="ul-ot-chip ul-ot-chip-orange">
                    {t("onlineTests.mock.chipJee")}
                  </span>
                </div>
              </div>
            </BrowserFrame>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OnlineTestsSection;
